const getBrandAssetPath = () => {
  const config = window.globalConfig || {};
  return config.BRAND_ASSET_PATH || config.brandAssetPath || '';
};

export const showBadgeOnFavicon = () => {
  const favicons = document.querySelectorAll('.favicon');

  favicons.forEach(favicon => {
    const basePath = getBrandAssetPath();
    const newFileName = `${basePath}/favicon-badge-${favicon.sizes[[0]]}.png`;
    favicon.href = newFileName;
  });
};

export const initFaviconSwitcher = () => {
  const favicons = document.querySelectorAll('.favicon');

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      favicons.forEach(favicon => {
        const basePath = getBrandAssetPath();
        const oldFileName = `${basePath}/favicon-${favicon.sizes[[0]]}.png`;
        favicon.href = oldFileName;
      });
    }
  });
};
